import Vue, { PluginObject } from 'vue';
import 'moment/locale/pl';
const moment: Function = require('moment');
import momentNamespace from 'moment';
/* tslint:disable-next-line */
momentNamespace.locale(process.env.VUE_APP_I18N_LOCALE);

declare module 'vue/types/vue' {
  interface Vue {
    $moment: Function
  }
  interface VueConstructor {
    $moment: Function
  }
}

const Plugin: PluginObject<any> = {
  install: (Vue) => {
    Vue.$moment = moment;
  },
};

Plugin.install = (Vue) => {
  Vue.$moment = moment;
  Object.defineProperties(Vue.prototype, {
    $moment: {
      get() {
        return moment;
      },
    },
  });
};

Vue.use(Plugin);

export const momentLocalized = moment;

export default Plugin;